import { render } from "./UserNotApproved.vue.ts?vue&type=template&id=c6b97519&scoped=true&ts=true!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./UserNotApproved.vue?vue&type=template&id=c6b97519&scoped=true&ts=true"
import script from "./UserNotApproved.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./UserNotApproved.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserNotApproved.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./UserNotApproved.vue?vue&type=script&setup=true&lang=ts"

import "./UserNotApproved.vue.css?vue&type=style&index=0&id=c6b97519&scoped=true&lang=css!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./UserNotApproved.vue?vue&type=style&index=0&id=c6b97519&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b97519"],['__file',"src/apps/merchant3/components/offers/v2/preparing/UserNotApproved.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6b97519"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6b97519', __exports__)) {
    api.reload('c6b97519', __exports__)
  }
  
  module.hot.accept("./UserNotApproved.vue.ts?vue&type=template&id=c6b97519&scoped=true&ts=true!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./UserNotApproved.vue?vue&type=template&id=c6b97519&scoped=true&ts=true", () => {
    api.rerender('c6b97519', render)
  })

}


export default __exports__